
<template>
  <m-layout>
    <div fill-height class="mails fill-height" style="width:100%; position:relative">
      <v-card-title class="m-page__title">
        <span class="headline">Mails</span>
      </v-card-title>


           <v-text-field
              ref="search"
              prepend-icon="search"
              clearable
              label="Search"
              single-line
              hide-details
              v-model="q"
              @blur="getData"
              @keyup.enter="onSearch"
              class="py-4"
            ></v-text-field>



      <v-layout row>
          <v-flex xs12>
        <v-expansion-panels popout ref="mailContainer">
          <v-expansion-panel v-for="(item, index) in mails" :key="index">



            <v-expansion-panel-header>
            <v-list three-line dense style="overflow: hidden;">


                <v-list-item

                  :key="item.title"
                >
                  <v-list-item-action>
                    <v-icon v-if="item.unread" color="primary">mail</v-icon>
                    <v-icon v-else color="primary">mail_outline</v-icon>

                  </v-list-item-action>
                  <v-list-item-content @click="toggle(index)">
                    <v-list-item-title>From : {{item.From}}</v-list-item-title>
                    <v-list-item-title>To : {{item.DeliveredTo}}</v-list-item-title>
                    <v-list-item-title>Subject : {{ item.Subject }}</v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text>{{ item.Date }}</v-list-item-action-text>
                    <v-icon
                      color="grey lighten-1"
                      v-if="selected.indexOf(index) < 0"
                    >star_border</v-icon>
                    <v-icon
                      color="yellow darken-2"
                      v-else
                    >star</v-icon>
                  </v-list-item-action>
                  <v-list-item-action @click.stop="onDelete(item)">
                    <v-btn icon>
                    <v-icon
                      color="primary"
                    >delete_outline</v-icon>
                    </v-btn>

                  </v-list-item-action>
                </v-list-item>


            </v-list>

            </v-expansion-panel-header>


          <v-expansion-panel-content>

            <v-card>
              <v-divider></v-divider>
              <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
              <v-card-text class="px-5" v-html="item.body"></v-card-text>
            </v-card>
          </v-expansion-panel-content>

          </v-expansion-panel>

        </v-expansion-panels>


          </v-flex>
        </v-layout>







      </div>
  </m-layout>
</template>


<script>
/* eslint-disable */
  export default {
    data () {
      return {
        mails: [],
        selected: [2],
        interval: null,
        q: ''
      }
    },
    methods: {
      parseMail (data) {
        var email = {};
        var h = data.payload.headers
        h.map(header => {
          var name = header.name.replace(new RegExp('-', 'g'), '');
          email[name] = header.value
        })
        email.id = data.id;
        email.unread = data.labelIds.indexOf('UNREAD') > -1;
        email.snippet = data.snippet

        var body = this.searchBodyRec(data.payload, 'text/html');
        email.body = this.cleanBody(body);
        if (!email.body) {
          email.body = this.searchBodyRec(data.payload, 'text/plain');
        }

        return email
      },
      searchBodyRec (payload, mimeType) {
        var app = this;
        if (payload.body && payload.body.size && payload.body.data && payload.mimeType === mimeType) {
          var encodedBody = payload.body.data.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
          return (decodeURIComponent(escape(window.atob(encodedBody))));
        } else if (payload.parts && payload.parts.length) {
          return payload.parts.flatMap(function (part) {
            return app.searchBodyRec(part, mimeType);
          }).filter(function (body) {
            return body;
          });
        }
      },
      cleanBody (body) {
        var cleanedBody = '', html, div, getStyle;
        if (body && body.length > 0) {
          html = body.toString(' ');
          html.replace(/src="?(cid:.*)"/, '');
          div = document.createElement('div');
          div.innerHTML = html;
          getStyle = div.querySelectorAll('style');
          if (getStyle.length) {
            for (var i = 0; i < getStyle.length; i++) {
              getStyle[i].remove();
            }
          }
          div.querySelectorAll('a').forEach(x => x.setAttribute('target', '_blank'));
          cleanedBody = div.outerHTML;
        }
        return cleanedBody
      },
      toggle (index) {
        const i = this.selected.indexOf(index)
        if (i > -1) {
          this.selected.splice(i, 1)
        } else {
          this.selected.push(index)
        }
      },
      onDelete (message) {
        console.log('delete', message);
        this.deleteMessage(message.id);
      },
      onSearch () {
        // e.target.onblur();
        this.$refs.search.blur();
        this.getData();
        console.log('search', this.$refs.search);
      },
      deleteMessage (id) {
        this.$http
        .post('service/gmail/deleteMessage', {id: id})
        .then(response => {
          console.log('data deleteMessage', response);
          this.getData();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      getData () {
        var app = this;
        this.$http
        .post('service/gmail/getMessages', {q: this.q})
        .then(response => {
          console.log('data getMessages', response.data);
          app.mails = response.data.map(app.parseMail);
          console.log('parsed messages', app.mails);
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      }
    },
    created () {
      this.getData();
      this.interval = setInterval(this.getData, 30000);
    },
    beforeDestroy () {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
</script>


<style lang="scss">
.theme--light .mails{
  .list--three-line.list--dense .list__tile {
      height: auto;
  }
  .list .list__tile--link:hover {
      background: none;
  }
}
</style>
